// extracted by extract-css-chunks-webpack-plugin
module.exports = {"form":"form___1jgKM","row":"row___3QbyF","full":"full___1Z2Zw","half":"half___1oMFp"};